import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import changeProPic from "../../images/profile/sidebar/changeProPic.svg";
import { logoutAction } from "../../redux/actions/userAction";
const Sidebar = ({ user }) => {
  const location = useLocation();
  const [isDropdownOpen, setisDropdownOpen] = useState(false);
  useEffect(() => {
    let menuButton = document.querySelector("#dropdown-example");
    let menuButton2 = document.querySelector("#dropdown-example2");
    menuButton.addEventListener("click", () => {
      menuButton2.classList.toggle("show");
    });
  }, []);

  const dispatch = useDispatch();
  const history2 = useNavigate();

  const logoutAb = () => {
    dispatch(logoutAction());
    history2("/login");
  };
  return (
    <div className="text-center bg-white lg:mt-5">
      <div className="e-profile-wrap pr-6 py-5">
        <div className="flex items-center">
          <div className="profile-thumb relative">
            <img
              className="mx-auto rounded-full h-[90px] w-[90px]"
              src={user?.profile_pic}
              alt=""
            />
            <NavLink to="/edit-profile">
              <img
                className="absolute right-0 bottom-0"
                src={changeProPic}
                alt=""
              />
            </NavLink>
          </div>
          <div className="profile-text text-start ml-3">
            <h4 className="text-black font-normal text-base">
              {user?.user?.first_name} {user?.user?.last_name}
            </h4>

            {user?.user?.role === "HUB" ? (
              <NavLink
                to={"/ehub/info"}
                className="text-[#0DC1D9] font-normal text-xs -mt-1"
              >
                E-Hub
              </NavLink>
            ) : (
              <button className="text-[#0DC1D9] font-normal text-xs -mt-1">
                E-Franchise
              </button>
            )}
          </div>
        </div>
        <ul className="pt-5 ">
          <li className="mb-3">
            <NavLink
              style={({ isActive }) => ({
                color: isActive ? "#fff" : "",

                background: isActive ? "#0DC1D9" : "",
              })}
              to="/my-panel"
              className="active flex justify-start items-center gap-2 p-2 px-3 rounded-md group hover:text-black hover:bg-[#EDFDFF]"
            >
              <span>
                <svg
                  className="h-4 w-4 fill-black"
                  viewBox="0 0 17 18"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M17.0013 9.03215C16.9649 9.12977 16.9372 9.23218 16.8893 9.3231C16.6874 9.71073 16.36 9.91555 15.9255 9.91746C14.0448 9.9232 12.1641 9.92512 10.2834 9.9165C9.64599 9.91363 9.20859 9.44561 9.20764 8.79191C9.20477 7.16006 9.20668 5.52821 9.20668 3.89635C9.20668 3.03305 9.20668 2.1707 9.20668 1.3074C9.20668 0.539804 9.39331 0.266074 10.0949 0C12.0981 0 14.1013 0 16.1045 0C16.2576 0.0689112 16.4223 0.120595 16.562 0.209605C16.8099 0.366569 16.9247 0.623072 17.0003 0.896802C17.0013 3.61018 17.0013 6.32164 17.0013 9.03215ZM9.92068 4.95012C9.92068 6.21732 9.92068 7.48356 9.92068 8.75076C9.92068 9.09627 10.0317 9.20729 10.3772 9.20729C12.1919 9.20729 14.0065 9.20729 15.8212 9.20729C16.183 9.20729 16.295 9.09436 16.295 8.72875C16.295 6.21732 16.295 3.70589 16.295 1.1935C16.295 0.82502 16.1772 0.707296 15.8078 0.707296C14.0046 0.707296 12.2005 0.707296 10.3973 0.707296C10.0317 0.707296 9.92068 0.81832 9.92068 1.18202C9.92068 2.43869 9.92068 3.6944 9.92068 4.95012Z"
                    // fill="#0DC1D9"
                  />
                  <path
                    d="M6.90658 0.00244141C7.0511 0.0675242 7.20902 0.113465 7.33823 0.201518C7.64354 0.407294 7.79094 0.712609 7.79285 1.07726C7.79764 2.24971 7.80147 3.42216 7.79189 4.5946C7.78711 5.21289 7.33632 5.6656 6.71803 5.66847C4.83829 5.67613 2.95759 5.67613 1.07784 5.66847C0.444242 5.6656 0.00206226 5.19853 0.00110516 4.56302C-0.000809036 3.42407 0.000148064 2.28417 0.00110516 1.14522C0.00110516 0.565216 0.267179 0.206304 0.826125 0.0301973C0.839524 0.0263689 0.851009 0.0120124 0.864409 0.00244141C2.87815 0.00244141 4.89188 0.00244141 6.90658 0.00244141ZM3.89363 4.95735C4.8067 4.95735 5.71882 4.95735 6.63189 4.95735C6.96687 4.95735 7.08077 4.84441 7.08077 4.50942C7.08173 3.39727 7.08173 2.28608 7.08077 1.17393C7.08077 0.823633 6.96496 0.707824 6.61179 0.707824C4.80287 0.707824 2.99395 0.707824 1.18504 0.707824C0.827082 0.707824 0.706487 0.828418 0.706487 1.18542C0.706487 2.28608 0.706487 3.38674 0.706487 4.48741C0.706487 4.83962 0.822296 4.95639 1.17259 4.95639C2.07897 4.9583 2.9863 4.95735 3.89363 4.95735Z"
                    // fill="#0DC1D9"
                  />
                  <path
                    d="M17.0007 16.1043C16.9816 16.1607 16.9624 16.2182 16.9433 16.2746C16.7988 16.6996 16.415 16.9963 15.969 16.9972C14.0615 17.002 12.1539 17.003 10.2464 16.9972C9.67793 16.9953 9.21948 16.5417 9.21182 15.955C9.19842 14.7605 9.19651 13.566 9.21278 12.3725C9.22139 11.7533 9.6942 11.3331 10.3355 11.3321C11.6735 11.3293 13.0115 11.3312 14.3495 11.3312C14.853 11.3312 15.3555 11.3302 15.8589 11.3312C16.4418 11.3331 16.8131 11.6164 16.9749 12.1773C16.9797 12.1926 16.9911 12.205 16.9997 12.2194C17.0007 13.5153 17.0007 14.8093 17.0007 16.1043ZM13.1158 12.0461C12.2028 12.0461 11.2906 12.0461 10.3776 12.0461C10.0301 12.0461 9.92008 12.1553 9.92008 12.5008C9.91912 13.6129 9.91912 14.7241 9.92008 15.8363C9.92008 16.177 10.0378 16.2947 10.3795 16.2947C12.1941 16.2957 14.0079 16.2947 15.8225 16.2947C16.169 16.2947 16.2944 16.1703 16.2944 15.8257C16.2953 14.7193 16.2953 13.6129 16.2944 12.5065C16.2944 12.1629 16.1776 12.0452 15.8378 12.0452C14.9305 12.0452 14.0232 12.0461 13.1158 12.0461Z"
                    // fill="#0DC1D9"
                  />
                  <path
                    d="M0.0021924 12.0482C0.0021924 10.7762 0.0021924 9.50326 0.0021924 8.23127C0.0021924 7.52589 0.446287 7.08275 1.15454 7.08275C2.98547 7.08179 4.8164 7.08179 6.64733 7.08275C7.3508 7.08371 7.7949 7.53067 7.79585 8.23701C7.79681 10.7762 7.79681 13.3154 7.79585 15.8546C7.79585 16.559 7.34889 17.0002 6.64159 17.0012C4.81066 17.0021 2.97973 17.0021 1.1488 17.0012C0.443415 17.0012 0.0031495 16.558 0.0031495 15.8488C0.0012353 14.5816 0.0021924 13.3154 0.0021924 12.0482ZM7.08186 12.0568C7.08186 10.7953 7.08186 9.53388 7.08186 8.27242C7.08186 7.90203 6.97753 7.79675 6.61192 7.79675C4.803 7.79675 2.99409 7.79675 1.18517 7.79675C0.819555 7.79675 0.708532 7.90777 0.708532 8.27147C0.708532 10.7829 0.708532 13.2943 0.708532 15.8067C0.708532 16.1771 0.826255 16.2968 1.19187 16.2968C2.99504 16.2968 4.79917 16.2968 6.60235 16.2968C6.97466 16.2968 7.08281 16.1867 7.08281 15.8086C7.08186 14.5567 7.08186 13.3068 7.08186 12.0568Z"
                    // fill="#0DC1D9"
                  />
                </svg>
              </span>
              <span className="lg:text-base text-sm  font-light">My Panel</span>
            </NavLink>
          </li>
          <li className="mb-3">
            <NavLink
              style={({ isActive }) => ({
                color: isActive ? "#fff" : "",
                background: isActive ? "#0DC1D9" : "",
              })}
              to="/referral"
              className="flex justify-start items-center gap-2 p-2 px-3 rounded-md group hover:bg-[#EDFDFF] hover:text-black"
            >
              <span>
                <svg
                  width="17"
                  height="17"
                  viewBox="0 0 17 17"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-4 w-4 fill-black"
                >
                  <path
                    d="M0.000887757 15.3068C0.0177387 15.2323 0.0345911 15.1582 0.0523289 15.085C0.298441 14.05 0.931681 13.3885 1.95914 13.109C1.97512 13.1045 1.99082 13.099 2.00615 13.0926C2.0159 13.0882 2.02477 13.0811 2.04739 13.0673C1.56891 12.5948 1.35428 12.0225 1.43632 11.3562C1.49973 10.8407 1.74673 10.4152 2.14583 10.0834C2.52624 9.77167 3.00894 9.61265 3.50005 9.63725C3.99116 9.66185 4.45557 9.86831 4.80296 10.2165C5.49429 10.9103 5.66147 12.1494 4.75551 13.0709C4.78411 13.0853 4.81375 13.0977 4.8442 13.1077C5.99272 13.4032 6.75988 14.3499 6.79891 15.5313C6.81088 15.9017 6.79891 16.2726 6.80379 16.6435C6.80694 16.715 6.79026 16.786 6.75559 16.8487C6.72092 16.9113 6.66961 16.9631 6.60734 16.9984H0L0.000887757 15.3068ZM6.20912 16.4252C6.20912 16.0468 6.23972 15.675 6.20336 15.3099C6.11467 14.4009 5.2974 13.6423 4.38523 13.6125C3.74445 13.5921 3.1019 13.5921 2.46112 13.6125C1.76979 13.633 1.24431 13.9675 0.867382 14.5442C0.484688 15.1276 0.573819 15.7811 0.571602 16.4288L6.20912 16.4252ZM1.98797 11.621C1.98932 11.9959 2.13947 12.3549 2.40538 12.619C2.67129 12.8831 3.03118 13.0307 3.40588 13.0294C3.78059 13.028 4.13941 12.8778 4.4034 12.6118C4.6674 12.3458 4.81495 11.9857 4.8136 11.6108C4.80917 10.838 4.15952 10.1912 3.39458 10.1983C3.02046 10.2035 2.66338 10.3556 2.40027 10.6217C2.13716 10.8878 1.9891 11.2467 1.98797 11.621Z"
                    // fill="url(#paint0_linear_1065_19797)"
                  />
                  <path
                    d="M10.3906 17C10.2376 16.9073 10.1884 16.7689 10.1937 16.5941C10.207 16.158 10.1822 15.7183 10.2257 15.2849C10.3317 14.2286 11.1033 13.3684 12.1356 13.1111C12.1671 13.1031 12.1981 13.0911 12.25 13.0747C11.7374 12.5534 11.5214 11.9425 11.6553 11.2287C11.7407 10.7666 11.9933 10.3521 12.3649 10.0646C12.7639 9.7463 13.27 9.59395 13.7783 9.63915C14.2866 9.68435 14.758 9.92364 15.0946 10.3073C15.4313 10.691 15.6073 11.1897 15.5862 11.6998C15.565 12.2098 15.3484 12.6922 14.9812 13.0467C15.2645 13.1798 15.5772 13.2872 15.845 13.4624C16.5789 13.9429 16.9581 14.6421 16.9931 15.5191C17.0077 15.878 16.9904 16.2383 16.9997 16.5976C17.0046 16.7751 16.9554 16.9082 16.798 16.9969L10.3906 17ZM10.7662 16.4233H16.4264C16.4264 16.0897 16.4432 15.7685 16.4233 15.4473C16.3935 14.9616 16.1839 14.5044 15.8355 14.165C15.487 13.8255 15.0247 13.628 14.5386 13.611C13.9089 13.5906 13.2775 13.5911 12.6478 13.611C11.9564 13.6341 11.4332 13.9726 11.0593 14.5489C10.6855 15.1252 10.7684 15.7773 10.7662 16.4211V16.4233ZM15.0073 11.6076C15.0016 10.8325 14.3506 10.1879 13.5883 10.1981C12.8105 10.2105 12.1764 10.8538 12.183 11.624C12.1897 12.3941 12.8349 13.0392 13.6047 13.029C13.9789 13.0257 14.3365 12.8743 14.5993 12.6079C14.8622 12.3416 15.0089 11.9819 15.0073 11.6076V11.6076Z"
                    // fill="url(#paint1_linear_1065_19797)"
                  />
                  <path
                    d="M9.85076 3.44683C10.3949 3.57193 10.8494 3.81993 11.2157 4.21876C11.6534 4.68292 11.8963 5.29752 11.8942 5.93565C11.8977 6.2956 11.8977 6.65524 11.8942 7.01459C11.8942 7.26524 11.79 7.36639 11.5394 7.36684C9.51463 7.36684 7.48957 7.36684 5.4642 7.36684C5.20346 7.36684 5.09836 7.26613 5.10146 7.00572C5.10812 6.51372 5.06732 6.0124 5.14581 5.53238C5.32319 4.46099 5.98081 3.78311 7.02291 3.4801C7.04952 3.47212 7.07568 3.46457 7.10184 3.45526C7.11587 3.44846 7.12937 3.4406 7.1422 3.43174C6.65441 2.94108 6.43623 2.35547 6.54089 1.66739C6.61112 1.19689 6.85277 0.76899 7.21936 0.466006C7.97942 -0.185259 9.11332 -0.147105 9.85431 0.537877C10.5048 1.1359 10.8476 2.40782 9.85076 3.44683ZM11.3243 6.7941C11.3243 6.46536 11.3332 6.1557 11.3243 5.84693C11.2897 4.86604 10.4867 4.028 9.50976 3.98364C8.88095 3.95391 8.24993 3.96855 7.62024 3.97121C7.219 3.9712 6.82819 4.09909 6.50453 4.33633C5.79058 4.84651 5.46465 5.83717 5.69524 6.7941H11.3243ZM8.49205 3.39359C8.86649 3.39443 9.22608 3.24717 9.49247 2.98391C9.75885 2.72065 9.91043 2.36273 9.91418 1.98814C9.92482 1.22596 9.27872 0.573368 8.50535 0.565382C7.73996 0.558284 7.09342 1.1989 7.08278 1.97483C7.07258 2.741 7.71469 3.38738 8.49205 3.3927V3.39359Z"
                    // fill="url(#paint2_linear_1065_19797)"
                  />
                  <path
                    d="M13.0693 3.68852L13.4241 3.2959L13.8179 3.73155L13.425 4.10643L13.0693 3.68852Z"
                    // fill="url(#paint3_linear_1065_19797)"
                  />
                  <path
                    d="M1.74824 9.59555L1.19038 9.66653L1.1416 9.08447H1.70389L1.74824 9.59555Z"
                    // fill="url(#paint4_linear_1065_19797)"
                  />
                  <path
                    d="M11.7075 2.78393L11.2197 2.54702C11.2964 2.36957 11.3683 2.20808 11.4468 2.0293L11.9749 2.28617C11.8818 2.45963 11.7971 2.61712 11.7075 2.78393Z"
                    // fill="url(#paint5_linear_1065_19797)"
                  />
                  <path
                    d="M14.1122 4.94628C14.0045 4.80121 13.9007 4.66102 13.7881 4.51019L14.2271 4.15527L14.5779 4.62553L14.1122 4.94628Z"
                    // fill="url(#paint6_linear_1065_19797)"
                  />
                  <path
                    d="M15.3915 6.19141L15.5778 6.74596L15.0368 6.90523C14.9787 6.73265 14.9237 6.56806 14.8643 6.3906L15.3915 6.19141Z"
                    // fill="url(#paint7_linear_1065_19797)"
                  />
                  <path
                    d="M1.41659 6.75244L1.96114 6.90417L1.8321 7.43121L1.28223 7.32075C1.32701 7.13175 1.36914 6.95252 1.41659 6.75244Z"
                    // fill="url(#paint8_linear_1065_19797)"
                  />
                  <path
                    d="M4.82382 3.05887L4.51562 2.58461L5.02248 2.28516C5.11117 2.4533 5.1972 2.61123 5.28855 2.78425L4.82382 3.05887Z"
                    // fill="url(#paint9_linear_1065_19797)"
                  />
                  <path
                    d="M12.4828 2.58496L12.9635 2.92257L12.6212 3.3742L12.1777 3.06143C12.2806 2.89861 12.3804 2.74378 12.4828 2.58496Z"
                    // fill="url(#paint10_linear_1065_19797)"
                  />
                  <path
                    d="M4.37695 3.37226L3.95922 3.7183C3.83417 3.57988 3.71134 3.4428 3.58008 3.29728L4.03372 2.92285L4.37695 3.37226Z"
                    // fill="url(#paint11_linear_1065_19797)"
                  />
                  <path
                    d="M14.4023 5.40711L14.8928 5.12451L15.1633 5.64446L14.6551 5.88802L14.4023 5.40711Z"
                    // fill="url(#paint12_linear_1065_19797)"
                  />
                  <path
                    d="M9.97226 16.0002L9.39578 16.0964C9.3714 15.9123 9.34745 15.7353 9.32129 15.5375L9.85342 15.4487C9.89156 15.6257 9.92925 15.8001 9.97226 16.0002Z"
                    // fill="url(#paint13_linear_1065_19797)"
                  />
                  <path
                    d="M2.41695 4.62402L2.88523 4.94522L2.59521 5.4035C2.43025 5.30856 2.27815 5.22205 2.10742 5.12445L2.41695 4.62402Z"
                    // fill="url(#paint14_linear_1065_19797)"
                  />
                  <path
                    d="M15.8094 7.90299L15.2498 7.96821L15.1611 7.43584L15.7132 7.32227L15.8094 7.90299Z"
                    // fill="url(#paint15_linear_1065_19797)"
                  />
                  <path
                    d="M1.70797 8.49341H1.14258L1.18692 7.90381L1.74389 7.97124L1.70797 8.49341Z"
                    // fill="url(#paint16_linear_1065_19797)"
                  />
                  <path
                    d="M7.15446 15.4536L7.68925 15.5361C7.66796 15.7265 7.64801 15.9044 7.62628 16.0964L7.0498 16.0077C7.08306 15.8218 7.11632 15.651 7.15446 15.4536Z"
                    // fill="url(#paint17_linear_1065_19797)"
                  />
                  <path
                    d="M8.78052 15.5864V16.1325H8.23242V15.5864H8.78052Z"
                    // fill="url(#paint18_linear_1065_19797)"
                  />
                  <path
                    d="M3.15906 3.70898L3.56614 4.09806L3.21138 4.50754L2.77148 4.15263C2.90097 4.00179 3.0238 3.86248 3.15906 3.70898Z"
                    // fill="url(#paint19_linear_1065_19797)"
                  />
                  <path
                    d="M1.83376 5.646L2.34372 5.88734C2.27277 6.05636 2.20714 6.21164 2.13308 6.38688L1.60449 6.18813L1.83376 5.646Z"
                    // fill="url(#paint20_linear_1065_19797)"
                  />
                  <path
                    d="M15.3081 8.51318H15.85V9.06064H15.3076L15.3081 8.51318Z"
                    // fill="url(#paint21_linear_1065_19797)"
                  />
                  <defs>
                    <linearGradient
                      id="paint0_linear_1065_19797"
                      x1="3.40222"
                      y1="9.63477"
                      x2="3.40222"
                      y2="16.9984"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stopColor="#028FF0" />
                      <stop offset="1" stopColor="#0DC1D9" />
                    </linearGradient>
                    <linearGradient
                      id="paint1_linear_1065_19797"
                      x1="13.5967"
                      y1="9.63135"
                      x2="13.5967"
                      y2="17"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stopColor="#028FF0" />
                      <stop offset="1" stopColor="#0DC1D9" />
                    </linearGradient>
                    <linearGradient
                      id="paint2_linear_1065_19797"
                      x1="8.49675"
                      y1="0"
                      x2="8.49675"
                      y2="7.36684"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stopColor="#028FF0" />
                      <stop offset="1" stopColor="#0DC1D9" />
                    </linearGradient>
                    <linearGradient
                      id="paint3_linear_1065_19797"
                      x1="13.4436"
                      y1="3.2959"
                      x2="13.4436"
                      y2="4.10643"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stopColor="#028FF0" />
                      <stop offset="1" stopColor="#0DC1D9" />
                    </linearGradient>
                    <linearGradient
                      id="paint4_linear_1065_19797"
                      x1="1.44492"
                      y1="9.08447"
                      x2="1.44492"
                      y2="9.66653"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stopColor="#028FF0" />
                      <stop offset="1" stopColor="#0DC1D9" />
                    </linearGradient>
                    <linearGradient
                      id="paint5_linear_1065_19797"
                      x1="11.5973"
                      y1="2.0293"
                      x2="11.5973"
                      y2="2.78393"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stopColor="#028FF0" />
                      <stop offset="1" stopColor="#0DC1D9" />
                    </linearGradient>
                    <linearGradient
                      id="paint6_linear_1065_19797"
                      x1="14.183"
                      y1="4.15527"
                      x2="14.183"
                      y2="4.94628"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stopColor="#028FF0" />
                      <stop offset="1" stopColor="#0DC1D9" />
                    </linearGradient>
                    <linearGradient
                      id="paint7_linear_1065_19797"
                      x1="15.221"
                      y1="6.19141"
                      x2="15.221"
                      y2="6.90523"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stopColor="#028FF0" />
                      <stop offset="1" stopColor="#0DC1D9" />
                    </linearGradient>
                    <linearGradient
                      id="paint8_linear_1065_19797"
                      x1="1.62169"
                      y1="6.75244"
                      x2="1.62169"
                      y2="7.43121"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stopColor="#028FF0" />
                      <stop offset="1" stopColor="#0DC1D9" />
                    </linearGradient>
                    <linearGradient
                      id="paint9_linear_1065_19797"
                      x1="4.90209"
                      y1="2.28516"
                      x2="4.90209"
                      y2="3.05887"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stopColor="#028FF0" />
                      <stop offset="1" stopColor="#0DC1D9" />
                    </linearGradient>
                    <linearGradient
                      id="paint10_linear_1065_19797"
                      x1="12.5706"
                      y1="2.58496"
                      x2="12.5706"
                      y2="3.3742"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stopColor="#028FF0" />
                      <stop offset="1" stopColor="#0DC1D9" />
                    </linearGradient>
                    <linearGradient
                      id="paint11_linear_1065_19797"
                      x1="3.97851"
                      y1="2.92285"
                      x2="3.97851"
                      y2="3.7183"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stopColor="#028FF0" />
                      <stop offset="1" stopColor="#0DC1D9" />
                    </linearGradient>
                    <linearGradient
                      id="paint12_linear_1065_19797"
                      x1="14.7828"
                      y1="5.12451"
                      x2="14.7828"
                      y2="5.88802"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stopColor="#028FF0" />
                      <stop offset="1" stopColor="#0DC1D9" />
                    </linearGradient>
                    <linearGradient
                      id="paint13_linear_1065_19797"
                      x1="9.64678"
                      y1="15.4487"
                      x2="9.64678"
                      y2="16.0964"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stopColor="#028FF0" />
                      <stop offset="1" stopColor="#0DC1D9" />
                    </linearGradient>
                    <linearGradient
                      id="paint14_linear_1065_19797"
                      x1="2.49632"
                      y1="4.62402"
                      x2="2.49632"
                      y2="5.4035"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stopColor="#028FF0" />
                      <stop offset="1" stopColor="#0DC1D9" />
                    </linearGradient>
                    <linearGradient
                      id="paint15_linear_1065_19797"
                      x1="15.4853"
                      y1="7.32227"
                      x2="15.4853"
                      y2="7.96821"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stopColor="#028FF0" />
                      <stop offset="1" stopColor="#0DC1D9" />
                    </linearGradient>
                    <linearGradient
                      id="paint16_linear_1065_19797"
                      x1="1.44324"
                      y1="7.90381"
                      x2="1.44324"
                      y2="8.49341"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stopColor="#028FF0" />
                      <stop offset="1" stopColor="#0DC1D9" />
                    </linearGradient>
                    <linearGradient
                      id="paint17_linear_1065_19797"
                      x1="7.36953"
                      y1="15.4536"
                      x2="7.36953"
                      y2="16.0964"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stopColor="#028FF0" />
                      <stop offset="1" stopColor="#0DC1D9" />
                    </linearGradient>
                    <linearGradient
                      id="paint18_linear_1065_19797"
                      x1="8.50647"
                      y1="15.5864"
                      x2="8.50647"
                      y2="16.1325"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stopColor="#028FF0" />
                      <stop offset="1" stopColor="#0DC1D9" />
                    </linearGradient>
                    <linearGradient
                      id="paint19_linear_1065_19797"
                      x1="3.16881"
                      y1="3.70898"
                      x2="3.16881"
                      y2="4.50754"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stopColor="#028FF0" />
                      <stop offset="1" stopColor="#0DC1D9" />
                    </linearGradient>
                    <linearGradient
                      id="paint20_linear_1065_19797"
                      x1="1.9741"
                      y1="5.646"
                      x2="1.9741"
                      y2="6.38688"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stopColor="#028FF0" />
                      <stop offset="1" stopColor="#0DC1D9" />
                    </linearGradient>
                    <linearGradient
                      id="paint21_linear_1065_19797"
                      x1="15.5788"
                      y1="8.51318"
                      x2="15.5788"
                      y2="9.06064"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stopColor="#028FF0" />
                      <stop offset="1" stopColor="#0DC1D9" />
                    </linearGradient>
                  </defs>
                </svg>
              </span>
              <span className="lg:text-base text-sm font-light">Referral</span>
            </NavLink>
          </li>
          <li className="mb-3">
            <button
              onClick={() => setisDropdownOpen(!isDropdownOpen)}
              id="dropdown-example"
              type="button"
              className={
                location.pathname === "/your-profit" ||
                location.pathname === "/save-account" ||
                location.pathname === "/withdraw" ||
                location.pathname === "/withdraw-history" ||
                location.pathname === "/add-account"
                  ? "flex justify-between items-center gap-2 p-2 px-3 rounded-md w-full bg-[#EDFDFF]"
                  : "flex justify-between items-center gap-2 p-2 px-3 rounded-md w-full"
              }
              data-collapse-toggle="dropdown-example"
            >
              <div className="flex items-center gap-3">
                <span>
                  <svg
                    width="17"
                    height="17"
                    viewBox="0 0 17 17"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className="fill-black"
                  >
                    <path
                      d="M16.9979 12.6083C16.9244 12.744 16.8657 12.8943 16.7743 13.0118C16.6276 13.199 16.4235 13.2612 16.2049 13.2622H16.0021C16.0021 13.3478 16.0021 13.4199 16.0021 13.4924C15.9929 14.1646 16.0104 14.839 15.9667 15.5083C15.9185 16.2572 15.2684 16.927 14.6026 16.9803C14.4426 16.993 14.2821 17 14.1221 17C9.99563 17 5.86926 17 1.74306 17C1.44795 17 1.15784 16.97 0.89017 16.8128C0.311598 16.4734 0.0264662 15.9263 0.00526853 15.2018C-0.00470686 14.8596 0.0019434 14.5165 0.00526853 14.1721C0.00526853 13.953 0.10045 13.8266 0.254653 13.8271C0.408856 13.8276 0.500711 13.9525 0.501958 14.1739C0.504036 14.4978 0.501958 14.8217 0.501958 15.1456C0.506114 15.8945 0.919675 16.3873 1.58054 16.4346C1.62502 16.4379 1.66907 16.4369 1.71355 16.4369C5.90626 16.4369 10.099 16.4369 14.2917 16.4369C14.6894 16.4369 15.0423 16.3274 15.2772 15.946C15.3748 15.7873 15.4725 15.5898 15.4783 15.4058C15.5016 14.6986 15.4879 13.9895 15.4879 13.258H15.2955C14.4937 13.258 13.6915 13.2537 12.8893 13.2612C12.711 13.2612 12.5913 13.2004 12.4916 13.0272C12.0972 12.3439 11.6955 11.6652 11.2862 10.9912C11.1773 10.811 11.1723 10.6636 11.2833 10.4834C11.6948 9.8047 12.0994 9.12088 12.4974 8.43191C12.5345 8.36044 12.5888 8.30221 12.654 8.26388C12.7192 8.22556 12.7927 8.20869 12.866 8.21521C13.679 8.22129 14.4924 8.21801 15.3054 8.21801H15.4954C15.4987 8.14687 15.5037 8.09258 15.5037 8.03782C15.5037 7.47101 15.5058 6.9042 15.5037 6.3374C15.5012 5.56605 15.0656 5.06478 14.3815 5.04137C14.3154 5.03903 14.2489 5.04137 14.1824 5.04137C10.1282 5.04137 6.07377 5.04215 2.01905 5.04371C1.48121 5.04371 0.955007 5.03108 0.502374 4.54758V12.8255C0.502374 13.126 0.421326 13.2608 0.245094 13.2547C0.0788378 13.2486 0.00443644 13.1185 0.00443644 12.8255C0.00443644 9.67396 0.00443644 6.52243 0.00443644 3.37091C0.00443644 2.44558 0.451246 1.75193 1.226 1.54973C1.52194 1.47251 1.84115 1.49029 2.14955 1.49497C2.32994 1.49731 2.41058 1.44817 2.443 1.23474C2.49205 0.916933 2.57725 0.606149 2.65082 0.293025C2.71441 0.0154728 2.81458 -0.047713 3.06313 0.0318551C4.26323 0.417527 5.46305 0.803666 6.66259 1.19027C6.75278 1.21929 6.84464 1.2441 6.93276 1.27967C7.37043 1.45659 7.82014 1.49731 8.284 1.49404C10.2866 1.4814 12.2887 1.48982 14.2913 1.48795C14.682 1.48795 15.0477 1.57314 15.3661 1.84648C15.8079 2.22653 16.0037 2.73811 16.0041 3.35359C16.0041 4.52527 16.0041 5.69648 16.0041 6.86723V7.08674C16.1014 7.09189 16.1874 7.09517 16.2735 7.10125C16.6126 7.12512 16.8396 7.31983 16.9609 7.67555C16.9721 7.70182 16.9852 7.72702 17 7.7509L16.9979 12.6083ZM2.25347 2.06271C1.97208 2.06271 1.71771 2.04446 1.46624 2.06646C1.05601 2.1025 0.765478 2.35805 0.599221 2.77368C0.432965 3.18931 0.47452 3.60353 0.714345 3.9761C0.958742 4.35896 1.30955 4.47925 1.71438 4.47878C5.88991 4.47597 10.0654 4.47691 14.241 4.48159C14.4779 4.48021 14.7138 4.51645 14.9417 4.58924C15.1358 4.6543 15.3087 4.79939 15.485 4.90517C15.485 4.29671 15.4896 3.67888 15.4804 3.05919C15.4708 2.94143 15.4383 2.82749 15.3852 2.72547C15.1678 2.24947 14.8075 2.0468 14.3424 2.04727C12.7715 2.04727 11.201 2.04727 9.63069 2.04727C9.58455 2.04727 9.53841 2.05382 9.49228 2.05757C9.82479 2.20407 10.1669 2.2944 10.4965 2.42545C11.6187 2.87103 12.7675 3.09289 13.96 2.98103C13.9816 2.98103 14.0041 2.98103 14.0261 2.98103C14.0481 2.98103 14.0593 2.98103 14.076 2.98337C14.236 3.00022 14.3374 3.10599 14.3399 3.25717C14.3424 3.40835 14.2406 3.52115 14.0834 3.538C14.0286 3.54409 13.9729 3.54175 13.9172 3.54175H1.72269C1.45626 3.54175 1.33075 3.44814 1.33407 3.25624C1.3374 3.06434 1.45876 2.98149 1.7148 2.98056C1.79792 2.98539 1.88124 2.98383 1.96418 2.97588C1.98577 2.97127 2.00615 2.96116 2.02373 2.94631C2.04131 2.93147 2.05563 2.91228 2.06559 2.89022C2.13127 2.62297 2.18863 2.35103 2.25347 2.06271ZM16.5 8.75299C16.3362 8.76142 16.1878 8.77546 16.0395 8.77546C15.0436 8.77764 14.048 8.77764 13.0527 8.77546C13.0042 8.77093 12.9556 8.78225 12.9127 8.80807C12.8697 8.83389 12.8343 8.87311 12.8108 8.92102C12.4843 9.48268 12.1533 10.042 11.8178 10.599C11.7554 10.7019 11.7505 10.7712 11.8149 10.8798C12.1546 11.4415 12.4888 12.0061 12.8174 12.5737C12.8404 12.6185 12.8744 12.655 12.9153 12.6787C12.9562 12.7023 13.0023 12.7122 13.0481 12.7071C14.0768 12.7033 15.1055 12.7071 16.1346 12.7043C16.4256 12.7043 16.4996 12.6186 16.5 12.2971V8.75299ZM2.56686 2.96886H10.2629L10.2691 2.93235L3.08767 0.621596L2.56686 2.96886ZM16.0116 8.21099C16.175 8.20023 16.3533 8.27137 16.4501 8.07713C16.4687 8.03187 16.4783 7.9826 16.4783 7.93274C16.4783 7.88287 16.4687 7.83361 16.4501 7.78835C16.3528 7.59691 16.1758 7.66057 16.0116 7.65963V8.21099Z"
                      // fill="url(#paint0_linear_1065_19822)"
                    />
                    <path
                      d="M13.7666 11.7626C13.5867 11.763 13.4108 11.7034 13.261 11.5912C13.1113 11.4791 12.9944 11.3194 12.9253 11.1324C12.8562 10.9454 12.8378 10.7396 12.8727 10.5409C12.9075 10.3422 12.9938 10.1595 13.1208 10.0161C13.2478 9.87273 13.4098 9.77497 13.5861 9.73523C13.7625 9.69549 13.9454 9.71556 14.1116 9.79289C14.2778 9.87023 14.4199 10.0014 14.5199 10.1697C14.62 10.338 14.6734 10.5359 14.6735 10.7385C14.6722 11.0092 14.5763 11.2684 14.4066 11.46C14.2368 11.6517 14.0069 11.7604 13.7666 11.7626ZM14.1756 10.7385C14.1763 10.6456 14.1525 10.5546 14.1072 10.477C14.0618 10.3994 13.997 10.3388 13.921 10.3028C13.845 10.2668 13.7612 10.2571 13.6802 10.2749C13.5993 10.2927 13.5249 10.3372 13.4665 10.4028C13.4081 10.4684 13.3683 10.552 13.3522 10.6431C13.3362 10.7342 13.3445 10.8286 13.3763 10.9144C13.408 11.0001 13.4617 11.0732 13.5304 11.1245C13.5992 11.1758 13.6799 11.2029 13.7624 11.2023C13.8711 11.1998 13.9747 11.1502 14.0516 11.0638C14.1286 10.9774 14.173 10.8608 14.1756 10.7385Z"
                      // fill="url(#paint1_linear_1065_19822)"
                    />
                    <defs>
                      <linearGradient
                        id="paint0_linear_1065_19822"
                        x1="8.5"
                        y1="0"
                        x2="8.5"
                        y2="17"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop stopColor="#028FF0" />
                        <stop offset="1" stopColor="#0DC1D9" />
                      </linearGradient>
                      <linearGradient
                        id="paint1_linear_1065_19822"
                        x1="13.7645"
                        y1="9.71533"
                        x2="13.7645"
                        y2="11.7626"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop stopColor="#028FF0" />
                        <stop offset="1" stopColor="#0DC1D9" />
                      </linearGradient>
                    </defs>
                  </svg>
                </span>
                <span className="lg:text-base text-sm font-light">Wallet</span>
              </div>
              <svg
                id="Layer_1"
                data-name="Layer 1"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 36 20.62"
                className="h-[10px] w-[10px] ml-auto mr-0"
              >
                <path
                  className="fill-[#0DC1D9]"
                  d="M18,7.69H33.75a2.93,2.93,0,0,1,1.06.15,1.91,1.91,0,0,1,.79,2.94c-.36.47-.8.89-1.21,1.33L20.11,27.29a2.71,2.71,0,0,1-4.24,0Q8.25,19.19.62,11.1a2,2,0,0,1,.75-3.32,3.14,3.14,0,0,1,.87-.09Z"
                  transform="translate(0 -7.69)"
                />
              </svg>
            </button>
            <ul
              id="dropdown-example2"
              className={
                location.pathname === "/your-profit" ||
                location.pathname === "/save-account" ||
                location.pathname === "/withdraw" ||
                location.pathname === "/withdraw-history" ||
                location.pathname === "/add-account"
                  ? "dropdown show pl-6"
                  : "dropdown pl-6"
              }
            >
              <li>
                <NavLink
                  style={({ isActive }) => ({
                    color: isActive ? "#0DC1D9" : "",
                  })}
                  to="/your-profit"
                  className="flex justify-start items-center gap-2 p-2 px-3 rounded-md"
                >
                  <span className="lg:text-base text-sm font-light">
                    Your Profit
                  </span>
                </NavLink>
              </li>
              <li>
                <NavLink
                  style={({ isActive }) => ({
                    color: isActive ? "#0DC1D9" : "",
                  })}
                  to="/save-account"
                  className="flex justify-start items-center gap-2 p-2 px-3 rounded-md"
                >
                  <span
                    className={`lg:text-base text-sm font-light ${
                      location.pathname === "/add-account"
                        ? "text-[#0DC1D9]"
                        : ""
                    }`}
                  >
                    Save Account
                  </span>
                </NavLink>
              </li>
              <li>
                <NavLink
                  style={({ isActive }) => ({
                    color: isActive ? "#0DC1D9" : "",
                  })}
                  to="/withdraw"
                  className="flex justify-start items-center gap-2 p-2 px-3 rounded-md"
                >
                  <span className="lg:text-base text-sm font-light">
                    Withdraw
                  </span>
                </NavLink>
              </li>
              <li>
                <NavLink
                  style={({ isActive }) => ({
                    color: isActive ? "#0DC1D9" : "",
                  })}
                  to="/withdraw-history"
                  className="flex justify-start items-center gap-2 p-2 px-3 rounded-md"
                >
                  <span className="lg:text-base text-sm font-light">
                    Withdraw History
                  </span>
                </NavLink>
              </li>
            </ul>
          </li>
          <li className="mb-3">
            <NavLink
              style={({ isActive }) => ({
                color: isActive ? "#fff" : "",
                background: isActive ? "#0DC1D9" : "",
              })}
              to="/reward"
              className="flex justify-start items-center gap-2 p-2 px-3 rounded-md hover:bg-[#EDFDFF] hover:text-black"
            >
              <span>
                <svg
                  width="16"
                  height="17"
                  viewBox="0 0 16 17"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  className="fill-black"
                >
                  <path
                    d="M2.9388 17C2.70836 16.8887 2.65343 16.7259 2.68955 16.4997C2.82028 15.6783 2.93116 14.8546 3.04918 14.0314C3.08478 13.7839 3.2145 13.6823 3.50038 13.6801C3.72267 13.6801 3.94547 13.669 4.16623 13.6801C4.6098 13.7067 4.95215 13.547 5.24261 13.2725C5.73145 12.8148 6.03005 12.2599 6.28846 11.6868C6.39477 11.4522 6.48276 11.2109 6.58145 10.9665C6.47564 10.9222 6.38764 10.8933 6.30727 10.8525C5.93339 10.6614 5.72992 10.3757 5.72331 9.99739C5.72331 9.8905 5.67703 9.84437 5.57631 9.79913C4.73691 9.43344 4.02962 8.87275 3.53242 8.17888C3.41034 8.00811 3.28368 7.96243 3.06597 7.96287C1.79427 7.96553 0.671609 7.30998 0.229057 6.28274C0.100731 5.97732 0.0291283 5.656 0.0169416 5.33091C-0.0135792 4.57378 0.00624987 3.81489 0.00726723 3.05688C0.00726723 2.77434 0.145636 2.65769 0.473226 2.65547C1.19657 2.65547 1.9194 2.65547 2.67072 2.65547C2.67072 2.42572 2.67428 2.20129 2.66614 1.9773C2.66614 1.94891 2.60611 1.91521 2.5644 1.89613C2.04606 1.6513 1.81156 1.21707 1.94687 0.746921C2.07658 0.295397 2.53135 0 3.10666 0C6.36221 0 9.61777 0 12.8733 0C13.4756 0 13.9309 0.293179 14.0595 0.759783C14.1918 1.24102 13.9436 1.66993 13.3911 1.91609C13.3744 1.92363 13.3586 1.9325 13.3403 1.94226V2.65592H13.6628C14.2844 2.65592 14.9062 2.65592 15.5281 2.65592C15.8659 2.65592 15.9981 2.77345 15.9986 3.07063C15.9986 3.81223 16.0017 4.55338 15.9986 5.29498C15.992 6.7937 14.6476 7.96509 12.9247 7.96243C12.7065 7.96243 12.5915 8.01876 12.4771 8.17755C11.9719 8.87361 11.2609 9.43808 10.4189 9.81155C10.3867 9.82732 10.3587 9.84894 10.3368 9.87496C10.315 9.90097 10.2998 9.93078 10.2923 9.96235C10.2689 10.4325 10.0161 10.7554 9.51145 10.9266C9.49356 10.933 9.47651 10.941 9.46058 10.9506C9.44423 10.963 9.42544 10.9728 9.40513 10.9794C9.60351 11.407 9.77647 11.8461 10.0094 12.259C10.1987 12.5838 10.4228 12.8923 10.6789 13.1802C10.9759 13.5231 11.3737 13.7209 11.8951 13.681C12.1107 13.671 12.3266 13.671 12.5422 13.681C12.7792 13.685 12.9211 13.795 12.9491 13.999C13.0748 14.8599 13.1968 15.7213 13.3245 16.5822C13.354 16.7818 13.2457 16.906 13.0636 17H2.9388ZM3.43374 1.99327V2.19818C3.43374 3.31014 3.43374 4.42209 3.43374 5.53405C3.42996 5.7387 3.44202 5.94334 3.46986 6.14658C3.68808 7.53974 4.52435 8.55988 5.94306 9.21898C5.97762 9.22959 6.01445 9.23335 6.05088 9.22997C6.08732 9.2266 6.12243 9.21617 6.15365 9.19946C6.36374 9.07394 6.58603 8.99366 6.84342 8.99366C7.61763 8.99366 8.39235 8.97991 9.16503 9.00297C9.3858 9.00918 9.61318 9.1041 9.81666 9.1937C9.92653 9.24204 9.99419 9.2589 10.102 9.20612C11.6723 8.44145 12.5188 7.27938 12.5635 5.71102C12.5976 4.52233 12.5707 3.33232 12.5701 2.14274C12.5701 2.09528 12.563 2.04782 12.5589 1.99327H9.88126C9.8365 1.99327 9.79223 1.99327 9.74798 1.99327C9.5033 1.98661 9.33646 1.85133 9.33697 1.66061C9.33748 1.46989 9.50432 1.33151 9.75002 1.33062C10.7648 1.3284 11.7802 1.33062 12.7955 1.33062C12.8525 1.33062 12.9099 1.33284 12.9664 1.33062C13.0644 1.32749 13.1573 1.29132 13.2254 1.22974C13.2934 1.16815 13.3315 1.08595 13.3315 1.0004C13.3315 0.914862 13.2934 0.832654 13.2254 0.771069C13.1573 0.709484 13.0644 0.673322 12.9664 0.670188C12.9155 0.66664 12.8647 0.670188 12.8138 0.670188H3.18398C3.12066 0.667662 3.05721 0.669591 2.99425 0.675955C2.90533 0.687742 2.82413 0.726755 2.7652 0.786003C2.70628 0.845251 2.67348 0.92086 2.67268 0.999279C2.67189 1.0777 2.70315 1.1538 2.76086 1.21395C2.81857 1.2741 2.89896 1.31436 2.98763 1.32751C3.05052 1.33462 3.11402 1.33684 3.17736 1.33417H6.12771C6.48785 1.33417 6.672 1.4486 6.66844 1.67037C6.66488 1.89214 6.48531 1.99815 6.13737 1.99815H3.43374V1.99327ZM3.76897 14.3481C3.67435 15.0134 3.58075 15.668 3.48715 16.3258H12.5198C12.4242 15.6605 12.3295 15.0045 12.2354 14.3481H3.76897ZM0.767754 3.32832C0.767754 3.99363 0.767754 4.64431 0.767754 5.29542C0.762702 5.581 0.829598 5.86407 0.963725 6.12464C1.09785 6.38521 1.29594 6.61694 1.544 6.80346C1.95501 7.12325 2.4408 7.28514 3.0151 7.30289C2.71294 6.62604 2.65393 5.93634 2.66868 5.23599C2.68089 4.65939 2.67123 4.08633 2.67123 3.51195V3.32788L0.767754 3.32832ZM13.3321 3.32832V3.52171C13.3321 4.22339 13.3382 4.92507 13.3286 5.62675C13.3275 5.88613 13.3033 6.14504 13.2564 6.40117C13.1989 6.70233 13.1037 6.99773 13.0203 7.30156C13.0493 7.30156 13.0803 7.30156 13.1114 7.30156C14.2656 7.23769 15.2153 6.3781 15.2331 5.36905C15.2443 4.7339 15.2356 4.09831 15.2356 3.46183C15.2356 3.41747 15.2311 3.37667 15.228 3.32877L13.3321 3.32832ZM10.1356 13.6734C10.0222 13.5435 9.92246 13.437 9.83039 13.3244C9.29679 12.6546 8.95801 11.9051 8.69146 11.132C8.65128 11.014 8.59379 10.9781 8.45746 10.982C8.14717 10.9905 7.83585 10.9918 7.52556 10.982C7.38872 10.9772 7.34447 11.0242 7.30835 11.1297C7.08758 11.7769 6.81392 12.4063 6.41461 12.9873C6.25387 13.2206 6.06616 13.4401 5.88507 13.6739L10.1356 13.6734ZM7.99914 9.65675C7.63798 9.65675 7.27733 9.65675 6.91667 9.65675C6.64961 9.65675 6.48328 9.78316 6.4787 9.97876C6.47413 10.1744 6.64962 10.3185 6.91922 10.3194C7.64052 10.3215 8.36201 10.3215 9.08365 10.3194C9.35224 10.3194 9.52874 10.1757 9.52213 9.97654C9.51552 9.7774 9.3502 9.65853 9.08111 9.65675C8.723 9.65498 8.36234 9.65675 8.00169 9.65675H7.99914Z"
                    // fill="url(#paint0_linear_1065_19837)"
                  />
                  <path
                    d="M6.12773 6.76786C6.15622 6.57004 6.19641 6.33452 6.2193 6.09812C6.22347 6.03084 6.19922 5.96457 6.15113 5.91183C5.99242 5.75349 5.81591 5.60978 5.65313 5.45454C5.2238 5.04648 5.43186 4.45924 6.05194 4.33505C6.29204 4.2867 6.53926 4.26275 6.77885 4.2113C6.86473 4.189 6.93878 4.14092 6.98791 4.07557C7.11101 3.90171 7.20919 3.71542 7.32415 3.53712C7.63343 3.05588 8.35015 3.04922 8.67062 3.52292C8.79576 3.70877 8.90004 3.90526 9.03077 4.08755C9.08233 4.1508 9.15779 4.19618 9.24391 4.21573C9.45857 4.26009 9.67934 4.28803 9.89757 4.3213C10.2028 4.36831 10.4271 4.50625 10.5304 4.76484C10.6336 5.02342 10.5583 5.26471 10.3391 5.46652C10.1733 5.61865 10.0013 5.76679 9.84466 5.92647C9.79723 5.98025 9.7739 6.04727 9.77904 6.11497C9.80142 6.33674 9.85331 6.55275 9.87264 6.77274C9.92046 7.30809 9.35888 7.65406 8.79322 7.44027C8.57856 7.3591 8.36541 7.27261 8.1594 7.17415C8.10891 7.14741 8.05086 7.13353 7.99179 7.13408C7.93273 7.13463 7.87502 7.14958 7.8252 7.17725C7.61308 7.27572 7.3974 7.37108 7.17562 7.45136C6.64761 7.64341 6.10077 7.30322 6.12773 6.76786ZM8.0012 3.8405C7.85216 4.084 7.70922 4.28759 7.59985 4.50581C7.49048 4.72403 7.31195 4.82338 7.04896 4.8531C6.77173 4.88503 6.49755 4.94181 6.22235 4.98616L6.17148 5.05669C6.3719 5.20926 6.56672 5.36716 6.77324 5.51353C7.00419 5.67631 7.0515 5.87502 6.99503 6.12074C6.94417 6.34872 6.92483 6.58246 6.8877 6.84415C7.19291 6.71419 7.46454 6.6073 7.72651 6.48577C7.80867 6.44404 7.90205 6.42206 7.99713 6.42206C8.09221 6.42206 8.18559 6.44404 8.26775 6.48577C8.53634 6.60686 8.81357 6.71508 9.11979 6.8406C9.0735 6.54476 9.03687 6.27731 8.98906 6.01207C8.97222 5.93601 8.97822 5.85745 9.00647 5.78401C9.03472 5.71057 9.08427 5.64474 9.15031 5.59293C9.36904 5.40265 9.57709 5.20261 9.81159 4.98572C9.50129 4.93693 9.22458 4.88237 8.9443 4.85266C8.70013 4.82693 8.53735 4.7329 8.43206 4.53686C8.30895 4.30888 8.1589 4.09154 8.0012 3.83961V3.8405Z"
                    // fill="url(#paint1_linear_1065_19837)"
                  />
                  <path
                    d="M8.38297 1.66338C8.38253 1.72917 8.35961 1.79336 8.31713 1.84773C8.27464 1.90211 8.21453 1.94421 8.14448 1.96865C8.07442 1.99309 7.99759 1.99877 7.92382 1.98495C7.85004 1.97114 7.78266 1.93846 7.73029 1.89109C7.67792 1.84372 7.64294 1.78381 7.62981 1.71902C7.61668 1.65423 7.62601 1.5875 7.65659 1.52735C7.68717 1.4672 7.73761 1.41637 7.80149 1.38134C7.86537 1.34632 7.93978 1.3287 8.0152 1.33072C8.11381 1.33426 8.20706 1.37081 8.27556 1.43277C8.34406 1.49472 8.38253 1.57732 8.38297 1.66338Z"
                    // fill="url(#paint2_linear_1065_19837)"
                  />
                  <path
                    d="M8.02195 15.008C8.26917 15.008 8.51639 15.0054 8.7631 15.008C9.00981 15.0107 9.17665 15.1526 9.17615 15.3393C9.17564 15.5261 9.00422 15.6684 8.76259 15.6702C8.25595 15.6732 7.74914 15.6732 7.24216 15.6702C7.00206 15.6702 6.8291 15.5247 6.8291 15.3389C6.8291 15.1531 7.00205 15.0111 7.24265 15.008C7.50259 15.0054 7.76253 15.008 8.02195 15.008Z"
                    // fill="url(#paint3_linear_1065_19837)"
                  />
                  <defs>
                    <linearGradient
                      id="paint0_linear_1065_19837"
                      x1="8"
                      y1="0"
                      x2="8"
                      y2="17"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stopColor="#028FF0" />
                      <stop offset="1" stopColor="#0DC1D9" />
                    </linearGradient>
                    <linearGradient
                      id="paint1_linear_1065_19837"
                      x1="8.00139"
                      y1="3.17187"
                      x2="8.00139"
                      y2="7.5055"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stopColor="#028FF0" />
                      <stop offset="1" stopColor="#0DC1D9" />
                    </linearGradient>
                    <linearGradient
                      id="paint2_linear_1065_19837"
                      x1="8.0035"
                      y1="1.33057"
                      x2="8.0035"
                      y2="1.99233"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stopColor="#028FF0" />
                      <stop offset="1" stopColor="#0DC1D9" />
                    </linearGradient>
                    <linearGradient
                      id="paint3_linear_1065_19837"
                      x1="8.00262"
                      y1="15.0068"
                      x2="8.00262"
                      y2="15.6724"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stopColor="#028FF0" />
                      <stop offset="1" stopColor="#0DC1D9" />
                    </linearGradient>
                  </defs>
                </svg>
              </span>
              <span className="lg:text-base text-sm font-light">Reward</span>
            </NavLink>
          </li>
          {user?.user?.role === "HUB" && (
            <li className="mb-3">
              <NavLink
                style={({ isActive }) => ({
                  color: isActive ? "#fff" : "",
                  background: isActive ? "#0DC1D9" : "",
                })}
                to="/purchase-history"
                className="flex justify-start items-center gap-2 p-2 px-3 rounded-md hover:bg-[#EDFDFF] hover:text-black"
              >
                <span>
                  <svg
                    width="16"
                    height="17"
                    viewBox="0 0 16 17"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className="fill-black"
                  >
                    <path
                      d="M2.9388 17C2.70836 16.8887 2.65343 16.7259 2.68955 16.4997C2.82028 15.6783 2.93116 14.8546 3.04918 14.0314C3.08478 13.7839 3.2145 13.6823 3.50038 13.6801C3.72267 13.6801 3.94547 13.669 4.16623 13.6801C4.6098 13.7067 4.95215 13.547 5.24261 13.2725C5.73145 12.8148 6.03005 12.2599 6.28846 11.6868C6.39477 11.4522 6.48276 11.2109 6.58145 10.9665C6.47564 10.9222 6.38764 10.8933 6.30727 10.8525C5.93339 10.6614 5.72992 10.3757 5.72331 9.99739C5.72331 9.8905 5.67703 9.84437 5.57631 9.79913C4.73691 9.43344 4.02962 8.87275 3.53242 8.17888C3.41034 8.00811 3.28368 7.96243 3.06597 7.96287C1.79427 7.96553 0.671609 7.30998 0.229057 6.28274C0.100731 5.97732 0.0291283 5.656 0.0169416 5.33091C-0.0135792 4.57378 0.00624987 3.81489 0.00726723 3.05688C0.00726723 2.77434 0.145636 2.65769 0.473226 2.65547C1.19657 2.65547 1.9194 2.65547 2.67072 2.65547C2.67072 2.42572 2.67428 2.20129 2.66614 1.9773C2.66614 1.94891 2.60611 1.91521 2.5644 1.89613C2.04606 1.6513 1.81156 1.21707 1.94687 0.746921C2.07658 0.295397 2.53135 0 3.10666 0C6.36221 0 9.61777 0 12.8733 0C13.4756 0 13.9309 0.293179 14.0595 0.759783C14.1918 1.24102 13.9436 1.66993 13.3911 1.91609C13.3744 1.92363 13.3586 1.9325 13.3403 1.94226V2.65592H13.6628C14.2844 2.65592 14.9062 2.65592 15.5281 2.65592C15.8659 2.65592 15.9981 2.77345 15.9986 3.07063C15.9986 3.81223 16.0017 4.55338 15.9986 5.29498C15.992 6.7937 14.6476 7.96509 12.9247 7.96243C12.7065 7.96243 12.5915 8.01876 12.4771 8.17755C11.9719 8.87361 11.2609 9.43808 10.4189 9.81155C10.3867 9.82732 10.3587 9.84894 10.3368 9.87496C10.315 9.90097 10.2998 9.93078 10.2923 9.96235C10.2689 10.4325 10.0161 10.7554 9.51145 10.9266C9.49356 10.933 9.47651 10.941 9.46058 10.9506C9.44423 10.963 9.42544 10.9728 9.40513 10.9794C9.60351 11.407 9.77647 11.8461 10.0094 12.259C10.1987 12.5838 10.4228 12.8923 10.6789 13.1802C10.9759 13.5231 11.3737 13.7209 11.8951 13.681C12.1107 13.671 12.3266 13.671 12.5422 13.681C12.7792 13.685 12.9211 13.795 12.9491 13.999C13.0748 14.8599 13.1968 15.7213 13.3245 16.5822C13.354 16.7818 13.2457 16.906 13.0636 17H2.9388ZM3.43374 1.99327V2.19818C3.43374 3.31014 3.43374 4.42209 3.43374 5.53405C3.42996 5.7387 3.44202 5.94334 3.46986 6.14658C3.68808 7.53974 4.52435 8.55988 5.94306 9.21898C5.97762 9.22959 6.01445 9.23335 6.05088 9.22997C6.08732 9.2266 6.12243 9.21617 6.15365 9.19946C6.36374 9.07394 6.58603 8.99366 6.84342 8.99366C7.61763 8.99366 8.39235 8.97991 9.16503 9.00297C9.3858 9.00918 9.61318 9.1041 9.81666 9.1937C9.92653 9.24204 9.99419 9.2589 10.102 9.20612C11.6723 8.44145 12.5188 7.27938 12.5635 5.71102C12.5976 4.52233 12.5707 3.33232 12.5701 2.14274C12.5701 2.09528 12.563 2.04782 12.5589 1.99327H9.88126C9.8365 1.99327 9.79223 1.99327 9.74798 1.99327C9.5033 1.98661 9.33646 1.85133 9.33697 1.66061C9.33748 1.46989 9.50432 1.33151 9.75002 1.33062C10.7648 1.3284 11.7802 1.33062 12.7955 1.33062C12.8525 1.33062 12.9099 1.33284 12.9664 1.33062C13.0644 1.32749 13.1573 1.29132 13.2254 1.22974C13.2934 1.16815 13.3315 1.08595 13.3315 1.0004C13.3315 0.914862 13.2934 0.832654 13.2254 0.771069C13.1573 0.709484 13.0644 0.673322 12.9664 0.670188C12.9155 0.66664 12.8647 0.670188 12.8138 0.670188H3.18398C3.12066 0.667662 3.05721 0.669591 2.99425 0.675955C2.90533 0.687742 2.82413 0.726755 2.7652 0.786003C2.70628 0.845251 2.67348 0.92086 2.67268 0.999279C2.67189 1.0777 2.70315 1.1538 2.76086 1.21395C2.81857 1.2741 2.89896 1.31436 2.98763 1.32751C3.05052 1.33462 3.11402 1.33684 3.17736 1.33417H6.12771C6.48785 1.33417 6.672 1.4486 6.66844 1.67037C6.66488 1.89214 6.48531 1.99815 6.13737 1.99815H3.43374V1.99327ZM3.76897 14.3481C3.67435 15.0134 3.58075 15.668 3.48715 16.3258H12.5198C12.4242 15.6605 12.3295 15.0045 12.2354 14.3481H3.76897ZM0.767754 3.32832C0.767754 3.99363 0.767754 4.64431 0.767754 5.29542C0.762702 5.581 0.829598 5.86407 0.963725 6.12464C1.09785 6.38521 1.29594 6.61694 1.544 6.80346C1.95501 7.12325 2.4408 7.28514 3.0151 7.30289C2.71294 6.62604 2.65393 5.93634 2.66868 5.23599C2.68089 4.65939 2.67123 4.08633 2.67123 3.51195V3.32788L0.767754 3.32832ZM13.3321 3.32832V3.52171C13.3321 4.22339 13.3382 4.92507 13.3286 5.62675C13.3275 5.88613 13.3033 6.14504 13.2564 6.40117C13.1989 6.70233 13.1037 6.99773 13.0203 7.30156C13.0493 7.30156 13.0803 7.30156 13.1114 7.30156C14.2656 7.23769 15.2153 6.3781 15.2331 5.36905C15.2443 4.7339 15.2356 4.09831 15.2356 3.46183C15.2356 3.41747 15.2311 3.37667 15.228 3.32877L13.3321 3.32832ZM10.1356 13.6734C10.0222 13.5435 9.92246 13.437 9.83039 13.3244C9.29679 12.6546 8.95801 11.9051 8.69146 11.132C8.65128 11.014 8.59379 10.9781 8.45746 10.982C8.14717 10.9905 7.83585 10.9918 7.52556 10.982C7.38872 10.9772 7.34447 11.0242 7.30835 11.1297C7.08758 11.7769 6.81392 12.4063 6.41461 12.9873C6.25387 13.2206 6.06616 13.4401 5.88507 13.6739L10.1356 13.6734ZM7.99914 9.65675C7.63798 9.65675 7.27733 9.65675 6.91667 9.65675C6.64961 9.65675 6.48328 9.78316 6.4787 9.97876C6.47413 10.1744 6.64962 10.3185 6.91922 10.3194C7.64052 10.3215 8.36201 10.3215 9.08365 10.3194C9.35224 10.3194 9.52874 10.1757 9.52213 9.97654C9.51552 9.7774 9.3502 9.65853 9.08111 9.65675C8.723 9.65498 8.36234 9.65675 8.00169 9.65675H7.99914Z"
                      // fill="url(#paint0_linear_1065_19837)"
                    />
                    <path
                      d="M6.12773 6.76786C6.15622 6.57004 6.19641 6.33452 6.2193 6.09812C6.22347 6.03084 6.19922 5.96457 6.15113 5.91183C5.99242 5.75349 5.81591 5.60978 5.65313 5.45454C5.2238 5.04648 5.43186 4.45924 6.05194 4.33505C6.29204 4.2867 6.53926 4.26275 6.77885 4.2113C6.86473 4.189 6.93878 4.14092 6.98791 4.07557C7.11101 3.90171 7.20919 3.71542 7.32415 3.53712C7.63343 3.05588 8.35015 3.04922 8.67062 3.52292C8.79576 3.70877 8.90004 3.90526 9.03077 4.08755C9.08233 4.1508 9.15779 4.19618 9.24391 4.21573C9.45857 4.26009 9.67934 4.28803 9.89757 4.3213C10.2028 4.36831 10.4271 4.50625 10.5304 4.76484C10.6336 5.02342 10.5583 5.26471 10.3391 5.46652C10.1733 5.61865 10.0013 5.76679 9.84466 5.92647C9.79723 5.98025 9.7739 6.04727 9.77904 6.11497C9.80142 6.33674 9.85331 6.55275 9.87264 6.77274C9.92046 7.30809 9.35888 7.65406 8.79322 7.44027C8.57856 7.3591 8.36541 7.27261 8.1594 7.17415C8.10891 7.14741 8.05086 7.13353 7.99179 7.13408C7.93273 7.13463 7.87502 7.14958 7.8252 7.17725C7.61308 7.27572 7.3974 7.37108 7.17562 7.45136C6.64761 7.64341 6.10077 7.30322 6.12773 6.76786ZM8.0012 3.8405C7.85216 4.084 7.70922 4.28759 7.59985 4.50581C7.49048 4.72403 7.31195 4.82338 7.04896 4.8531C6.77173 4.88503 6.49755 4.94181 6.22235 4.98616L6.17148 5.05669C6.3719 5.20926 6.56672 5.36716 6.77324 5.51353C7.00419 5.67631 7.0515 5.87502 6.99503 6.12074C6.94417 6.34872 6.92483 6.58246 6.8877 6.84415C7.19291 6.71419 7.46454 6.6073 7.72651 6.48577C7.80867 6.44404 7.90205 6.42206 7.99713 6.42206C8.09221 6.42206 8.18559 6.44404 8.26775 6.48577C8.53634 6.60686 8.81357 6.71508 9.11979 6.8406C9.0735 6.54476 9.03687 6.27731 8.98906 6.01207C8.97222 5.93601 8.97822 5.85745 9.00647 5.78401C9.03472 5.71057 9.08427 5.64474 9.15031 5.59293C9.36904 5.40265 9.57709 5.20261 9.81159 4.98572C9.50129 4.93693 9.22458 4.88237 8.9443 4.85266C8.70013 4.82693 8.53735 4.7329 8.43206 4.53686C8.30895 4.30888 8.1589 4.09154 8.0012 3.83961V3.8405Z"
                      // fill="url(#paint1_linear_1065_19837)"
                    />
                    <path
                      d="M8.38297 1.66338C8.38253 1.72917 8.35961 1.79336 8.31713 1.84773C8.27464 1.90211 8.21453 1.94421 8.14448 1.96865C8.07442 1.99309 7.99759 1.99877 7.92382 1.98495C7.85004 1.97114 7.78266 1.93846 7.73029 1.89109C7.67792 1.84372 7.64294 1.78381 7.62981 1.71902C7.61668 1.65423 7.62601 1.5875 7.65659 1.52735C7.68717 1.4672 7.73761 1.41637 7.80149 1.38134C7.86537 1.34632 7.93978 1.3287 8.0152 1.33072C8.11381 1.33426 8.20706 1.37081 8.27556 1.43277C8.34406 1.49472 8.38253 1.57732 8.38297 1.66338Z"
                      // fill="url(#paint2_linear_1065_19837)"
                    />
                    <path
                      d="M8.02195 15.008C8.26917 15.008 8.51639 15.0054 8.7631 15.008C9.00981 15.0107 9.17665 15.1526 9.17615 15.3393C9.17564 15.5261 9.00422 15.6684 8.76259 15.6702C8.25595 15.6732 7.74914 15.6732 7.24216 15.6702C7.00206 15.6702 6.8291 15.5247 6.8291 15.3389C6.8291 15.1531 7.00205 15.0111 7.24265 15.008C7.50259 15.0054 7.76253 15.008 8.02195 15.008Z"
                      // fill="url(#paint3_linear_1065_19837)"
                    />
                    <defs>
                      <linearGradient
                        id="paint0_linear_1065_19837"
                        x1="8"
                        y1="0"
                        x2="8"
                        y2="17"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop stopColor="#028FF0" />
                        <stop offset="1" stopColor="#0DC1D9" />
                      </linearGradient>
                      <linearGradient
                        id="paint1_linear_1065_19837"
                        x1="8.00139"
                        y1="3.17187"
                        x2="8.00139"
                        y2="7.5055"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop stopColor="#028FF0" />
                        <stop offset="1" stopColor="#0DC1D9" />
                      </linearGradient>
                      <linearGradient
                        id="paint2_linear_1065_19837"
                        x1="8.0035"
                        y1="1.33057"
                        x2="8.0035"
                        y2="1.99233"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop stopColor="#028FF0" />
                        <stop offset="1" stopColor="#0DC1D9" />
                      </linearGradient>
                      <linearGradient
                        id="paint3_linear_1065_19837"
                        x1="8.00262"
                        y1="15.0068"
                        x2="8.00262"
                        y2="15.6724"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop stopColor="#028FF0" />
                        <stop offset="1" stopColor="#0DC1D9" />
                      </linearGradient>
                    </defs>
                  </svg>
                </span>
                <span className="lg:text-base text-sm font-light">
                  Purchase History
                </span>
              </NavLink>
            </li>
          )}

          <li className="mb-3">
            <NavLink
              to={"/login"}
              className="flex justify-start items-center gap-2 p-2 px-3 rounded-md hover:bg-[#EDFDFF] hover:text-black"
              onClick={logoutAb}
            >
              <span>
                <svg
                  width="17"
                  height="17"
                  viewBox="0 0 17 17"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  className="fill-black"
                >
                  <path
                    d="M8.39109 0.00135126C8.62355 0.09804 8.79169 0.238555 8.78682 0.49835C8.78664 0.615629 8.73929 0.728634 8.65404 0.815278C8.56878 0.901921 8.45174 0.955976 8.32578 0.966883C8.24846 0.972608 8.17087 0.97472 8.09332 0.973209C6.55965 0.973209 5.02599 0.968691 3.49184 0.973209C2.47378 0.977727 1.72279 1.40063 1.26761 2.2514C1.10582 2.55321 1.05026 2.87988 1.05026 3.21648C1.05026 6.73523 1.05026 10.2543 1.05026 13.7736C1.05026 15.074 2.07367 16.0219 3.48161 16.0264C5.00309 16.0309 6.52506 16.0264 8.04703 16.0264C8.14803 16.0222 8.24918 16.0307 8.34772 16.0517C8.46049 16.0833 8.55805 16.15 8.624 16.2406C8.68994 16.3311 8.72025 16.4399 8.70982 16.5487C8.70022 16.66 8.64968 16.7649 8.56665 16.8459C8.48361 16.9268 8.37312 16.9788 8.25366 16.9933C8.20622 16.9977 8.15852 16.9992 8.11087 16.9978C6.55137 16.9978 4.9953 17.0028 3.43775 16.9978C1.77201 16.9915 0.403069 15.9586 0.075088 14.4617C0.0273222 14.2283 0.0047868 13.9909 0.00782854 13.7533C0.00392981 10.2508 0.0161176 6.75014 3.53506e-05 3.2463C-0.00678744 1.78964 0.974713 0.580582 2.33245 0.166718C2.56784 0.0948788 2.81444 0.0546698 3.05616 0L8.39109 0.00135126Z"
                    fill="url(#paint0_linear_1065_19851)"
                  />
                  <path
                    d="M15.1916 8.99409H14.9479C11.5346 8.99409 8.12125 8.99409 4.70791 8.99409C4.60072 8.99694 4.4936 8.98692 4.38919 8.96427C4.27879 8.93287 4.18287 8.86813 4.11673 8.78037C4.05059 8.6926 4.01801 8.58685 4.02418 8.47994C4.03034 8.37302 4.07489 8.27109 4.15075 8.19037C4.2266 8.10964 4.32941 8.05475 4.4428 8.03444C4.54297 8.02079 4.64421 8.01505 4.74543 8.01727H15.1921C15.1214 7.94678 15.081 7.90431 15.0381 7.86455C14.3042 7.18382 13.5699 6.50323 12.8353 5.8228C12.7145 5.71075 12.6126 5.59282 12.6116 5.42249C12.6066 5.33342 12.6293 5.24488 12.6771 5.16747C12.7249 5.09007 12.7957 5.02707 12.8811 4.98603C12.966 4.93784 13.0646 4.91486 13.164 4.92019C13.2633 4.92552 13.3584 4.95891 13.4367 5.01585C13.4891 5.05219 13.5381 5.09271 13.5829 5.13694C14.6424 6.11828 15.7015 7.10008 16.7604 8.08233C17.0806 8.37917 17.0806 8.62812 16.7604 8.92542C15.6931 9.9155 14.626 10.9056 13.559 11.8957C13.4006 12.0425 13.2252 12.1306 12.9981 12.0723C12.911 12.0515 12.8312 12.01 12.7666 11.9519C12.7019 11.8939 12.6547 11.8212 12.6294 11.7412C12.6042 11.6611 12.6018 11.5763 12.6225 11.4951C12.6432 11.4139 12.6863 11.3391 12.7476 11.278C12.9055 11.1122 13.0814 10.9618 13.25 10.805C13.8491 10.2492 14.4484 9.69381 15.0479 9.13868C15.0898 9.09937 15.1268 9.05916 15.1916 8.99409Z"
                    // fill="url(#paint1_linear_1065_19851)"
                  />
                  <defs>
                    <linearGradient
                      id="paint0_linear_1065_19851"
                      x1="4.39346"
                      y1="0"
                      x2="4.39346"
                      y2="17"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stopColor="#000" />
                      <stop offset="1" stopColor="#000" />
                    </linearGradient>
                    <linearGradient
                      id="paint1_linear_1065_19851"
                      x1="10.512"
                      y1="4.91943"
                      x2="10.512"
                      y2="12.0905"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stopColor="#000" />
                      <stop offset="1" stopColor="#000" />
                    </linearGradient>
                  </defs>
                </svg>
              </span>
              {/* <Link
                to={"/login"}
                className="lg:text-base text-sm text-black font-light"
                onClick={logoutAb}
              > */}
              Logout
              {/* </Link> */}
            </NavLink>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default Sidebar;
